(function () {

	'use strict';

	/*global $:true */

	let cologicViewService = {

		initView: function () {

			let that = this;

            this.ageCheck();

			this.checkMenue();
			this.showToTop();
			this.bindBurger();
			this.enableAccordion();
			this.toggleMenue();
			this.setMbVideoHeight();
            this.checkVideoPlaySetup();
			$('.toTopWrapper').click(this.pageToTop);
			$(window).scroll(function () {
				that.toggleMenue();
				that.showToTop();
			});
            $(window).on('hashchange', function() {
                that.manageScroll();
            });

            $(window).on('resize', function() {
                that.checkMenue();
                that.setMbVideoHeight();
                that.scaleYoutubeBox();
                    $('.mbSliderBox').each(function (){
                        let tempNr = $(this).data('tag-elem-nr');
                        $("#mbSlide-"+tempNr).iosSlider('destroy', true);
                        setTimeout(function () {
                            that.initMBBoxSlider("#mbSlide-"+tempNr, 1, tempNr);
                        }, 100);
                    });

                    // $('.produktInnerElement.sideImages.active').each(function (){
                    //     let tempNr = $(this).data('tag-elem-nr');
                    //     console.log($("#sliderContainer-"+tempNr));
                    //     // $("#sliderContainer-"+tempNr).iosSlider('destroy', true);
                    //     // setTimeout(function () {
                    //     //     that.initSideImageSlider($('#sliderContainer-' + tempNr), tempNr);
                    //     //     }, 100);
                    // });

            });
			this.equalHeight();
            this.setYoutubeBox();
            this.manageScroll();
            this.bindScrollDown();
            this.startTabMB();
            this.controlVarTabBar();
            this.clickBdBox();
		},

        ageCheck: function() {
            // if($('.pageLayout-4').length < 1){
            //     let baseUrl = $('base').prop('href');
            //     let that = this;
            //     let ageStatus = this.getLocalStorage('age');
            //     if(!ageStatus){
            //         $('#ageCheck').addClass('active');
            //         $('.agCheckBtn.age-notok').on('click', function(){
            //             that.addItemToLocalStorage('age','no');
            //             window.location.href = baseUrl+'fassbrause';
            //         });
            //         $('.agCheckBtn.age-ok').on('click', function(){
            //             that.addItemToLocalStorage('age','yes');
            //             $('#ageCheck').removeClass('active');
            //         });
            //     }else{
            //         if(ageStatus == 'yes'){
            //             $('#ageCheck').removeClass('active');
            //         }else{
            //             window.location.href = baseUrl+'fassbrause';
            //         }
            //     }
            // }

        },

		//--------------------------------------
        clickBdBox: function() {
            $('.bdSliderbox').on('click', function(){
                let oldIndex = parseInt($(this).css('--index'));
                let orgindex = parseInt($(this).css('--orgindex'));
                let total = parseInt($(this).css('--items'));
                let diffIndex = 1 -oldIndex;
                $('.bdContentBox').removeClass('active');
                $('.bdSliderbox').each(function (){
                    $(this).removeClass('active');
                    let oldIndex = parseInt($(this).css('--index'));
                    let newIndex = oldIndex + diffIndex;
                    $(this).css('--index', newIndex);
                    if((newIndex > -4) && (newIndex < 6)){
                        $(this).addClass('seeme');
                    }else{
                        $(this).removeClass('seeme');
                    }
                    if(newIndex == 0){
                        $(this).addClass('zero');
                    }else{
                        $(this).removeClass('zero');
                    }
                    if(newIndex > 1){
                        $(this).addClass('before');
                    }else{
                        $(this).removeClass('before');
                    }
                    if(newIndex < 1){
                        $(this).addClass('after');
                    }else{
                        $(this).removeClass('after');
                    }

                });
                $('.bdContentBox.item'+orgindex).addClass('active');
                if(orgindex != 1){
                    $('.bdSliderHeadline ').hide();
                }else{
                    $('.bdSliderHeadline ').show();
                }
                if(orgindex < 2){
                    $('.backstep').removeClass('active');
                }else{
                    $('.backstep').addClass('active');
                }
                if(orgindex == total) {
                    $('.nextstep').removeClass('active');
                }else{
                    $('.nextstep').addClass('active');
                }

                $(this).addClass('active');

            });
        },

        backStep: function() {
            let activeBox = parseInt($('.bdSliderbox.active').css('--index'));
            $('.bdImage.main').each(function(){
                let bdr = parseInt($(this).css('--bdr')) ;
                let newbdr = bdr + 1;
                $(this).css('--bdr', newbdr);
            });
            $('.bdSliderbox').removeClass('active');
            $('.bdContentBox').removeClass('active');
            $('.bdSliderbox').each(function (){
                // console.log($(this).css('--index'));
                let oldIndex = parseInt($(this).css('--index'));
                let total = parseInt($(this).css('--items'));
                let orgindex = parseInt($(this).css('--orgindex'));
                if((total - oldIndex) == (oldIndex + 1)){
                // if((total - oldIndex) == (oldIndex)){
                    // $('.nextstep').hide();
                    $(this).css('--index', orgindex);
                    if(orgindex == 1){
                        $(this).addClass('active');
                        if(orgindex != 1){
                            $('.bdSliderHeadline ').hide();
                        }else{
                            $('.bdSliderHeadline ').show();
                        }
                    }
                }else{
                    $(this).css('--index', (oldIndex + 1));
                    if((oldIndex + 1)  == activeBox){
                        $('.bdContentBox.item'+orgindex).addClass('active');
                        $(this).addClass('active');
                        if(orgindex != 1){
                            $('.bdSliderHeadline ').hide();
                        }else{
                            $('.bdSliderHeadline ').show();
                        }

                    }
                    if((oldIndex + 1)  == orgindex){
                        $('.backstep').removeClass('active')
                    }
                }
                if((orgindex - total) <= (oldIndex -1)) {
                    $('.nextstep').addClass('active');
                }
                let finalindex = parseInt($(this).css('--index'));
                if((finalindex > -4) && (finalindex < 6)){
                    $(this).addClass('seeme');
                }else{
                    $(this).removeClass('seeme');
                }

                if(finalindex > 1){
                    $(this).addClass('before');
                }else{
                    $(this).removeClass('before');
                }
                if(finalindex < 1){
                    $(this).addClass('after');
                }else{
                    $(this).removeClass('after');
                }
                if(finalindex == 0){
                    $(this).addClass('zero');
                }else{
                    $(this).removeClass('zero');
                }
                // $('.bdContentBox.item'+orgindex).addClass('active');


            });
        },


        nextStep: function() {

            let activeBox = parseInt($('.bdSliderbox.active').css('--index'));
            $('.bdImage.main').each(function(){
                let bdr = parseInt($(this).css('--bdr')) ;
                let newbdr = bdr - 1;
                $(this).css('--bdr', newbdr);
            });
            $('.bdSliderbox').removeClass('active');
            $('.bdContentBox').removeClass('active');
            $('.bdSliderbox').each(function (){
                // console.log($(this).css('--index'));
                let oldIndex = parseInt($(this).css('--index'));
                let total = parseInt($(this).css('--items'));
                let orgindex = parseInt($(this).css('--orgindex'));
                if((orgindex - total) == (oldIndex -2)){
                    $('.nextstep').removeClass('active');
                // if((orgindex - total) == (oldIndex -1)){
                //     $(this).css('--index', orgindex);
                //     if(orgindex == 1){
                //         $(this).css('--bdr', 1);
                //         $('.bdContentBox.item'+orgindex).addClass('active');
                //     }
                //         $('.backstep').removeClass('active')
                }
                if((orgindex - total) <= (oldIndex -1)){
                    $(this).css('--index', (oldIndex - 1));
                    if((oldIndex - 1)  == activeBox){
                        $(this).addClass('active');
                        if(orgindex != 1){
                            $('.bdSliderHeadline ').hide();
                        }else{
                            $('.bdSliderHeadline ').show();
                        }

                        $('.bdContentBox.item'+orgindex).addClass('active');

                    }
                    // if(total > (oldIndex - 1)){
                        $('.backstep').addClass('active');
                    // }else{
                    //     $('.backstep').hide();
                    //
                    // }
                }
                let finalindex = parseInt($(this).css('--index'));
                if((finalindex > -4) && (finalindex < 6)){
                    $(this).addClass('seeme');
                }else{
                    $(this).removeClass('seeme');
                }
                if(finalindex > 1){
                    $(this).addClass('before');
                }else{
                    $(this).removeClass('before');
                }
                if(finalindex < 1){
                    $(this).addClass('after');
                }else{
                    $(this).removeClass('after');
                }
                if(finalindex == 0){
                    $(this).addClass('zero');
                }else{
                    $(this).removeClass('zero');
                }
                // $('.bdContentBox.item'+orgindex).addClass('active');

            });
        },


        isiOS: function () {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        },

		scrollToY: function (_y) {
			$('html, body').animate({scrollTop: _y}, '200');
		},

		scrollToId: function (_id) {
			let offSet = $('.header-container').innerHeight();
			this.scrollToY($('#' + _id).offset().top - (offSet + 50));
		},

		equalHeight: function () {
			let addedClasses = "";
			let addedClassesCol = "";
			if (arguments[0] !== undefined) addedClasses = arguments[0];
			if (arguments[1] !== undefined) addedClassesCol = arguments[1];
			// $('.sameHeightRow .mubo-b-1').css("height", "auto");
			setTimeout(function () {
				$('.sameHeightRow' + addedClasses).each(function () {
					let highestBox = 0;
					$('.mubo-b-1' + addedClassesCol, this).each(function () {
                        if ($(this).height() > highestBox) {
							highestBox = $(this).height();
							// highestBox = $(this).height();
						}
					});
					$('.mubo-b-1' + addedClassesCol, this).height(highestBox);
				});

			}, 100);

			// $('.sameImageHeightRow .mubo-b-1 .image').css("height", "auto");
			setTimeout(function () {
				$('.sameImageHeightRow').each(function () {
					let highestBox = 0;
					$('.mubo-b-1 .image', this).each(function () {
                        if ($(this).height() > highestBox) {
							highestBox = $(this).height();
						}
					});
					$('.mubo-b-1 .image', this).height(highestBox);
				});

			}, 100);

			// $('.sameWidthHeight .mubo-b-1').css("height", "auto");
			setTimeout(function () {
				$('.sameWidthHeight').each(function () {
					let highestBox = 0;
					$('.mubo-b-1 .image', this).each(function () {
                        if ($(this).height() > highestBox) {
							highestBox = $(this).width();
						}
					});
					$('.mubo-b-1', this).height(highestBox);
				});

			}, 100);

		},

        manageScroll: function(){
            let tempHash = window.location.hash;
            if(tempHash!=undefined&&tempHash!=''&&tempHash!=null&&tempHash!=0){
                let offSet = $('#headerMain').innerHeight();
                let tempPosition = $(tempHash).offset().top;
                let newPosition = tempPosition - offSet;
                $('html, body').animate({
                    scrollTop:newPosition
                },'slow');

            }

        },

        getURLPath: function(param){
		    let paramVal = false;
		    try {
                if($.QueryString[param]){
                    paramVal = $.QueryString[param];
                }
            }catch (e) {

            }
            return paramVal;
        },

        setMbVideoHeight: function(){
            $('.v-std').each(function(){
                $(this).css('height',(($(this).width() / 16) * 9));
                $(this).parent().css('height',(($(this).width() / 16) * 9));
            });
            $('.v-qua').each(function(){
                $(this).css('height', $(this).width() );
                $(this).parent().css('height', $(this).width() );
            });
            $('.v-high').each(function(){
                $(this).css('height',(($(this).width() / 9) * 16));
                $(this).parent().css('height',(($(this).width() / 9) * 16));

            });
            $('.boxVideo').each(function(){
                $(this).css('height',(($('.mb-background-video', this).width() / 16) * 8.75));
            });
        },


        startTab: function(_selector) {
            $(_selector + ' .vBarTabItem').on('click', function(){

                let boxid = $(this).data('tabitem');
                let itemNum = $(this).data('itemnum');
                $(_selector + ' .varTabBarInner').attr('data-stepnum', itemNum);
                $(_selector + ' .vBarTabItem').removeClass('active')
                $(this).addClass('active')
                $(_selector + ' .variantItem').removeClass('active');
                $(_selector + ' ' + boxid).addClass('active');
            });
        },

        clickItemTab: function(_elem) {
                let boxid = $(_elem).data('tabitem');
                let itemNum = $(_elem).data('itemnum');
                // console.log(boxid);
                // console.log(itemNum);
                $(boxid).parent().find('.varTabBarInner').attr('data-stepnum', itemNum);
                $(boxid).parent().find('.vBarTabItem').removeClass('active')
                $(_elem).addClass('active')
                $(boxid).parent().find('.variantItem').removeClass('active');
                $(boxid).addClass('active');
        },

        controlVarTabBar: function() {
            let that = this;
          $('.varTabBarButtonNext').each(function(){
             $(this).on('click', function (){
                let parentWidth = $(this).parent().find('.varTabBarInner').css('width');
                let elementWidth = $(this).parent().find('.varTabBarInner .vBarTabItem').css('width');
                let activeElement = $(this).parent().find('.varTabBarInner .vBarTabItem.active');
                if($(activeElement)[ 0 ] == $(this).parent().find('.varTabBarInner .vBarTabItem:last-child')[ 0 ]){
                    return;
                }else{
                    $(activeElement).removeClass('active');
                    let parentItemNum = $(this).parent().find('.varTabBarInner').attr('data-stepnum');
                    that.clickItemTab($(activeElement).next('.vBarTabItem'));
                    if(parseInt(parentItemNum) > 2){
                        let oldLeft = $(this).parent().find('.varTabBarInner').css('left');
                        let newLeft = 'calc('+oldLeft+' - '+elementWidth+')';
                        $(this).parent().find('.varTabBarInner').css('left', newLeft);
                    }
                    if($(activeElement).next()[ 0 ] == $(this).parent().find('.varTabBarInner .vBarTabItem:last-child')[ 0 ]){
                        $(this).addClass('disabled');
                    }
                    if($(activeElement)[ 0 ] == $(this).parent().find('.varTabBarInner .vBarTabItem:first-child')[ 0 ]){
                        $(this).parent().find('.varTabBarButtonPrev').removeClass('disabled');
                    }
                 }
             });
          });
          $('.varTabBarButtonPrev').each(function(){
             $(this).on('click', function (){
                let parentWidth = $(this).parent().find('.varTabBarInner').css('width');
                let elementWidth = $(this).parent().find('.varTabBarInner .vBarTabItem').css('width');
                let activeElement = $(this).parent().find('.varTabBarInner .vBarTabItem.active');
                 // console.log($(this).parent().find('.varTabBarInner .vBarTabItem:last-child')[ 0 ]);
                if($(activeElement)[ 0 ] == $(this).parent().find('.varTabBarInner .vBarTabItem:first-child')[ 0 ]){
                    return;
                }else{
                    let parentItemNum = $(this).parent().find('.varTabBarInner').attr('data-stepnum');
                    that.clickItemTab($(activeElement).removeClass('active').prev('.vBarTabItem'));
                    let oldLeft = $(this).parent().find('.varTabBarInner').css('left');
                    if((parseInt(parentItemNum) > 1) &&  (parseInt(oldLeft) < 0 )) {
                        let newLeft = 'calc(' + oldLeft + ' + ' + elementWidth + ')';
                        $(this).parent().find('.varTabBarInner').css('left', newLeft);
                    }
                    if($(activeElement).prev()[ 0 ] == $(this).parent().find('.varTabBarInner .vBarTabItem:first-child')[ 0 ]){
                        $(this).addClass('disabled');
                    }
                    if($(activeElement)[ 0 ] == $(this).parent().find('.varTabBarInner .vBarTabItem:last-child')[ 0 ]){
                        $(this).parent().find('.varTabBarButtonNext').removeClass('disabled');
                    }

                }
             });
          });



          $('.tagBarBtnNext').each(function(){
             $(this).on('click', function (){
                let parentWidth = parseFloat($(this).parent().find('.tagSectionInner').css('width'));
                let elementRawWidth = parseFloat($(this).parent().find('.tagSectionInner .tagBtn').css('width'));
                let elementMarginRight = parseFloat($(this).parent().find('.tagSectionInner .tagBtn').css('margin-right'));
                let elementMarginLeft = parseFloat($(this).parent().find('.tagSectionInner .tagBtn').css('margin-left'));
                 let oldLeft = parseFloat($(this).parent().find('.tagSectionInner').css('left'));
                 let elementWidth = elementRawWidth + elementMarginRight + elementMarginLeft;
                //  console.log(parentWidth);
                // console.log(elementWidth);
                // console.log(oldLeft);
                 let curActiveYyear = $(this).parent().find('.tagSectionInner').find('.tagBtn.active');
                 $(curActiveYyear).next('.tagBtn').click();
                if(((oldLeft - elementWidth) * -1) < parentWidth ){
                    let newLeft = oldLeft - elementWidth;
                    // let newLeft = 'calc('+oldLeft+' - '+elementWidth+')';
                    $(this).parent().find('.tagSectionInner').css('left', newLeft+'px');
                    if(((oldLeft - (2 * elementWidth)) * -1) >= parentWidth ){
                        $(this).addClass('disabled');
                    }
                    if(newLeft < 0){
                        $(this).parent().find('.tagBarBtnPrev').removeClass('disabled');
                    }
                 }
             });
          });
            $('.tagBarBtnPrev').each(function(){
             $(this).on('click', function (){
                 let parentWidth = parseFloat($(this).parent().find('.tagSectionInner').css('width'));
                 let elementRawWidth = parseFloat($(this).parent().find('.tagSectionInner .tagBtn').css('width'));
                 let elementMarginRight = parseFloat($(this).parent().find('.tagSectionInner .tagBtn').css('margin-right'));
                 let elementMarginLeft = parseFloat($(this).parent().find('.tagSectionInner .tagBtn').css('margin-left'));
                 let oldLeft = parseFloat($(this).parent().find('.tagSectionInner').css('left'));
                 let elementWidth = elementRawWidth + elementMarginRight + elementMarginLeft;
                 let curActiveYyear = $(this).parent().find('.tagSectionInner').find('.tagBtn.active');
                 $(curActiveYyear).prev('.tagBtn').click();
                 if(oldLeft < 0 ){
                     let newLeft = oldLeft + elementWidth;
                     // let newLeft = 'calc('+oldLeft+' - '+elementWidth+')';
                     $(this).parent().find('.tagSectionInner').css('left', newLeft+'px');
                     if((oldLeft + elementWidth) >= 0 ){
                         $(this).addClass('disabled');
                     }
                     if((oldLeft * -1) < parentWidth ){
                         $(this).parent().find('.tagBarBtnNext').removeClass('disabled');
                     }
                 }
             });
          });
        },

        showToTop: function () {
                let slimit = 100;
                let bScroll = Number($("body").scrollTop());
                let hScroll = Number($("html").scrollTop());
                if (hScroll < slimit && bScroll < slimit)
                    $(".toTopWrapper.showDialog").removeClass('showDialog');
                if (hScroll > slimit || bScroll > slimit)
                    $(".toTopWrapper").addClass('showDialog');
        },

        pageToTop() {
            $("html,body").animate({scrollTop: 0}, '500');
        },

		//---------------------------------------------------------
        checkVideoPlaySetup: function(){
            let that = this;
                $(this).css({'height':(($('.mb-background-video', this).width() / 16) * 10)});
                $('.mb-background-video').each(function(){
                   $('.std-video-inner', this).each(function(){
                       let elem = this;
                           $(elem).attr('loop',true);
                           $(elem).attr('controls',true);
                           elem.play();
                   });
               });
        },


		// Check if element is scrolled into view
		isInViewport: function (el) {

            var top = el.offsetTop;
            var left = el.offsetLeft;
            var width = el.offsetWidth;
            var height = el.offsetHeight;

            while(el.offsetParent) {
                el = el.offsetParent;
                top += el.offsetTop;
                left += el.offsetLeft;
            }
            return (
                top < (window.pageYOffset + window.innerHeight) &&
                left < (window.pageXOffset + window.innerWidth) &&
                (top + height) > window.pageYOffset &&
                (left + width) > window.pageXOffset
            );

		},


        bindBurger: function() {
            let that = this;
            let mainMenu =  $('#headerMain');
            $('#hamburgerIcon').on('click', function(){
                // console.log('click');
                that.toggleMenu(mainMenu)
            });
        },



        bindLevel2Menue: function() {
            $('.headLi').on('mouseenter', function(){
                if(!$('#headerMain').hasClass('extend')){
                    $('#headerMain').addClass('extend');
                }
                $('#headerMain .menList.level2').removeClass('show');
                $(this).next('.menList.level2').addClass('show');
            });
            $('.menListWrapper').on('mouseleave', function(){
                $('#headerMain .menList.level2').removeClass('show');
                $('#headerMain').removeClass('extend');
            });
        },



        bindScrollDown: function() {
            let that = this;
            if($('.scrollDownArrow').length > 0){
                let clickIt = '<div class="clickDown"></div>';
                $('.scrollDownArrow').append(clickIt);
                $('.scrollDownArrow .clickDown').on('click', function(){
                    // console.log('scrollDown to:');
                    // console.log($(this).offset().top + $(this).height());
                    that.scrollToY($(this).offset().top + $(this).height());
                });
            }
        },


        bindContactButton: function() {
            let that = this;
            let cbtn = document.querySelectorAll('.btnContact');
            let mainMenu =  document.querySelector('#headerMain');
            if (typeof(cbtn) != 'undefined' && cbtn != null){
                cbtn.forEach((item)=>{
                    item.addEventListener("click", ()=>{
                        that.toggleMenu(mainMenu)
                    });
                });
            }
        },

        startTabMB: function() {
            if($('.mb-tab').length > 0) {
                $('.mb-tab .tabControlBtn').on('click', function () {
                    let boxid = $(this).data('tabitem');
                    $(this).parent().find('.tabControlBtn').removeClass('active')
                    $(this).addClass('active')
                    $(this).parent().parent().parent().find('.mubo-b-1').removeClass('active');
                    $(this).parent().parent().parent().find( '#' + boxid).addClass('active');
                });
            }
        },




        startControl: function(_selector) {
            let that = this;
            let isMobileView = false;
            if($('body').innerWidth() < 769){
                isMobileView = true;
            }
            let sel = '#c' + _selector;
            $(sel + ' .produktInnerControl .innerControl').on('click', function(){
                if($(this).parent().hasClass('start')){
                    $(this).parent().removeClass('start').addClass('position1');
                    $(sel + ' .produktInnerElement.mainImage').removeClass('active');
                    $(sel + ' .produktInnerElement.mainInfo').removeClass('active');
                    $(sel + ' .produktInnerElement.detailInfo').addClass('active');
                    $(sel + ' .produktInnerElement.variantTabs').addClass('active');
                    $(sel + ' .produktInnerElement.sideImages').addClass('active');
                    $(sel + ' .produktInnerControl.mobile').addClass('position1');
                    setTimeout(function (){
                        cologic.initSideImageSlider($('#sliderContainer-' + _selector), _selector);
                    },1500);
                    if(isMobileView){
                        let positiontemp = $(this).parent().parent().offset().top - 90;
                        that.scrollToY(positiontemp);
                    }

                }else if($(this).parent().hasClass('position1')){
                    $(this).parent().removeClass('position1').addClass('position2');
                    $(sel + ' .produktInnerElement.detailInfo').removeClass('active');
                    // $(sel + ' .produktInnerElement.sideImages').addClass('active');
                    // cologic.initSideImageSlider($('#sliderContainer-' + _selector), _selector);
                }else if($(this).parent().hasClass('position2')){
                    $(this).parent().removeClass('position2').addClass('start');
                    $(sel + ' .produktInnerElement.detailInfo').removeClass('active');
                    $(sel + ' .produktInnerElement.variantTabs').removeClass('active');
                    $(sel + ' .produktInnerElement.sideImages').removeClass('active');
                    $(sel + ' .produktInnerElement.mainImage').addClass('active');
                    $(sel + ' .produktInnerElement.mainInfo').addClass('active');

                }

            });

            $(sel + ' .produktInnerControl .innerControlClose').on('click', function(){
                if($(this).parent().hasClass('position1')){
                    $(sel + ' .produktInnerControl').removeClass('position1').addClass('start');
                    // $(sel + ' .produktInnerElement.mobile').removeClass('position1').addClass('start');
                    // $(this).parent().removeClass('position1').addClass('start');
                    $(sel + ' .produktInnerElement.detailInfo').removeClass('active');
                    $(sel + ' .produktInnerElement.variantTabs').removeClass('active');
                    $(sel + ' .produktInnerElement.sideImages').removeClass('active');
                    $(sel + ' .produktInnerElement.mainImage').addClass('active');
                    $(sel + ' .produktInnerElement.mainInfo').addClass('active');


                }

            });

        },



        showCrInfo: function(_elem){
            $(_elem).parent().click(function(e) {
                e.preventDefault();
            });
            // let curhref = window.location.href;
            $(_elem).find('p').toggleClass('showInfo');
            setTimeout(function (){
                $(_elem).parent().unbind('click');
            },1000);
        },



        checkMenue: function() {

            let allWidth = $('body').innerWidth();
            var barrierVal = 0;
            if (allWidth < 1200){
                $('.menListWrapper ').each(function () {
                    $('.menList.level1', this).accordion({
                        animate: 300,
                        header: '.headLi',
                        collapsible: true,
                        heightStyle: 'content',
                        active: true
                    });
                });

                $("#headerMain").addClass("headerSmall");

            }else{
                $('.menListWrapper ').each(function () {
                    if($('.menList.level1', this).accordion('instance') !== undefined){
                        $('.menList.level1', this).accordion('destroy');
                    }
                });
                $("#headerMain").removeClass("headerSmall");
                this.bindLevel2Menue();

            }
            if (allWidth < 900){
                $('.footerRight').accordion({
                        animate: 300,
                        header: '.footerMenHeader',
                        collapsible: true,
                        heightStyle: 'content',
                        active: true
                });
            }else{
                if($('.footerRight').accordion('instance') !== undefined){
                    $('.footerRight').accordion('destroy');
                }
            }
            let mainMenu =  $('#headerMain');

            if (!$(mainMenu).hasClass('open') || !$(mainMenu).hasClass('headerSmall')) {
                $('body').css('overflow-y', 'auto');
            }

        },


    toggleMenu: function (menu = $('#headerMain')) {

            if ($(menu).hasClass('open')) {
                $(menu).removeClass('open');
                $('body').css('overflow-y', 'auto');

                // let scrollY = document.body.style.top;
                // document.body.style.position = '';
                // document.body.style.top = '';
                // window.scrollTo(0, parseInt(scrollY || '0') * -1);
            } else {
                // menu.classList.add("open");
                $(menu).addClass('open');
                $('body').css('overflow-y', 'hidden');
                // When the modal is shown, we want a fixed body
                // document.body.style.top = -1 * window.scrollY+"px";
                // document.body.style.position = 'fixed';
            }

    },



        toggleMenue: function (menu) {
            let slimit=100;
            let bScroll=Number($("body").scrollTop());
            let hScroll=Number($("html").scrollTop());
            if(hScroll<slimit && bScroll<slimit)
                $('#headerMain').removeClass('headerStick');
            if(hScroll>slimit || bScroll>slimit)
                $('#headerMain').addClass('headerStick');
        },



        setYoutubeBox: function () {
			$('.mubo-b-1').each(function () {

                let parent_h = (($(this).width() / 16) * 9);
                let parent_w = $(this).width();
				if ($('.videoLinkEl', this).length > 0) {
					let srcVal = $('.videoLinkEl', this).data('src-value');
					let ytSrcFind;
					if (srcVal.indexOf('youtu.be') !== -1) {
						ytSrcFind = srcVal.lastIndexOf('/');
					} else {
						ytSrcFind = srcVal.lastIndexOf('=');
					}
					let ytSrcClean = srcVal.slice(ytSrcFind + 1);
					$('.videoLinkEl', this).find('iframe').attr('src', 'https://www.youtube.com/embed/' + ytSrcClean + '?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=0').attr('width', parent_w).attr('height', parent_h);  //.attr('autoplay','1').get(0).click();
				}
			});



        },

        scaleYoutubeBox: function () {
			$('.mubo-b-1').each(function () {
                let parent_h = (($(this).width() / 16) * 9);
                let parent_w = $(this).width();
				if ($('.videoLinkEl', this).length > 0) {
					$('.videoLinkEl', this).find('iframe').attr('width', parent_w).attr('height', parent_h);
				}
			});


        },



        enableAccordion: function(_el){
            $('.acboOuter ').each(function () {
                    $('.acboInner', this).accordion({
                        animate: 300,
                        header: '.acbo-head',
                        // header: 'h3',
                        collapsible: true,
                        heightStyle: 'content',
                        active: true
                    });
            });

            $('.acboInnerContent').each(function () {
                    $(this).accordion({
                    // $('.acbo-element', this).accordion({
                        animate: 300,
                        header: '.acbo-subHead',
                        // header: 'h3',
                        collapsible: true,
                        heightStyle: 'content',
                        active: true
                    });
            });

            $('.event .inboInnerRight').each(function () {
                    $('.inboInnerRightBox2', this).accordion({
                        animate: 300,
                        header: '.inboInnerRightBox2Head',
                        // header: 'h3',
                        collapsible: true,
                        heightStyle: 'content',
                        active: true
                    });
            });

		},


		removeOverlay: function(_el){
			$(_el).hide().parent().find('video').get(0).play();
		},

        slideLoadedSingle: function(){
                let _vid = $('.innerVideo');
                if(_vid.length > 0){
                    var mediaVideo = _vid.get(0);
                        _vid.parent().css('z-index','-1');
                        _vid.parent().css('display','flex');
                        _vid.parent().parent().find('.mubo-bg').remove();
                        mediaVideo.play();


            }


		},
        showMenu: function() {
            //$("#menuContent").show();
            $("body").addClass("menu-open");
        },

        closeMenu: function() {
            //$("#menuContent").hide();
            $("body").removeClass("menu-open");
        },

        //------------------------------------------------------------





    };

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicViewService);
}());